var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPensionBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "theChar",
    "data-name": "pension",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 159.63 198.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "b15cc582-8132-44a5-a283-d0a907234c0a",
    "data-name": "border",
    d: "M7.7,33.33c2.39-3,0-18.46,7.69-23.86s24.74,1.65,28.84,5.18-1.71,16.61-1.82,20,16.84-2,18.28-3.06,1-16.34,4.76-25.31S85.53.2,89.32,3.35s1,16.64.92,18.61,3.48,5.54,7.69,4.82,11.15-13.27,19.61-12.13,13,7.39,15,14.22,12,17.75,15.56,21.75,10.08,48.22,11.11,54.17-4.78,16.92-4.46,17.89-5.44,11.32-8.54,11.54-.31,8.65-1.08,21.56-1.62,22.25-3.64,24.74-2.76,16.63-6.06,17.31-5.41-1.5-9.2-5.46-25-1.37-28.35-2.94,3.07-9.72,1.36-13.19-23.66-5-32.55-4-3.4,7.48-8.92,10.32S44.91,186.22,39,187.9s-23.79-2.7-26.67-5.32-4.63-14.11-5-27.93-1.7-53.42-3.27-56.54.2-16.68,0-25.1S-1,44.69.54,40.71C2.24,36.18,5.32,36.38,7.7,33.33Z",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeMiterlimit: 10,
      strokeWidth: "0.5px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPensionBorder);
export default __webpack_public_path__ + "static/media/pension-border.cd615dc2.svg";
export { ForwardRef as ReactComponent };